import {ReactNode} from "react";
import {Button, Kbd, Modal, Text} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
import {Trans, useTranslation} from "react-i18next";
import {DibJsonNode} from "../../types";
import {useOverflowsHorizontally} from "../../useOverflowsHorizontally";
import ArrowsMaximize from "../../../../assets/arrows-maximize.svg?react";
import classes from "./table.module.css";

type Props = {
    node: DibJsonNode;
    children: ReactNode[];
};

export const Table = ({node, children}: Props) => {
    const {t} = useTranslation();
    const kind = node.kind ?? "";
    const [opened, {open, close}] = useDisclosure(false);
    const [overflows, wrapperRef] = useOverflowsHorizontally<HTMLDivElement>();

    const noBorder = kind.includes("tbNoBorder");

    return (
        <>
            <div className={overflows ? classes.tableOuter : undefined}>
                {overflows && (
                    <div className={classes.tableToolbar}>
                        <Button
                            variant="subtle"
                            size="compact-sm"
                            color="dark"
                            onClick={open}
                            className={classes.fullscreenButton}
                            leftSection={
                                <ArrowsMaximize width={14} height={14} />
                            }
                        >
                            {t("table.openFullscreen", "Open in full screen")}
                        </Button>
                    </div>
                )}
                <div
                    className={classes.tableWrapper}
                    ref={wrapperRef}
                >
                    <table className={noBorder ? "tbNoBorder" : undefined}>
                        {children}
                    </table>
                </div>
            </div>
            <Modal
                fullScreen
                radius={0}
                opened={opened}
                onClose={close}
                title={
                    <Text>
                        <Trans
                            i18nKey="table.fullscreenTitle"
                            components={{span: <Kbd />}}
                        />
                    </Text>
                }
                centered
            >
                <table
                    className={`${classes.modalTable} ${noBorder ? "tbNoBorder" : ""}`}
                >
                    {children}
                </table>
            </Modal>
        </>
    );
};
